export enum WhatsappType {
  Business = 2,
  Normal = 1,
}
